export default __webpack_public_path__ + "static/media/fuel-tank.b3ff4d85.svg";